<template>
    <div>
        <transition name="fade">
        <div v-if="list">
            <div class="my-list" v-if="!isChatOpen">
                <div class="sc-header">
                <div class="title">{{$t('general_companyChat')}}</div>
                <div @click="closeModal" class="close-button">
                    <i  class="el-icon-close"></i>
                </div>
                </div>
                <div class="list">
                    <div @click="enterRoom(groupChat.userName)">
                        <el-card class="box-card">
                            <div class="flex box-card__wrap">
                                <div class="flex">
                                    <div class="photo-group">
                                        <img v-if="groupChat.userAvatarUrl" :src="groupChat.userAvatarUrl">
                                    </div>
                                    <span class="name">{{groupChat.userName}}</span>
                                </div>
                            </div>
                        </el-card>
                    </div>
                    <!--{{activeUserList}}-->
                    <transition-group name="flip-list" tag="div">
                        <div class="flip-list-move" v-for="item in activeUserList" :key="item.companyUserId" @click="enterRoom(item.userName, item.companyUserId, item.active, item.newMessageCount)">
                            <div>
                                <el-card class="box-card">
                                    <div class="flex box-card__wrap">
                                        <div class="flex">
                                            <div class="photo">
                                                <el-badge :value="item.newMessageCount" :hidden="item.newMessageCount === 0" class="item-badge">
                                                </el-badge>
                                                <img v-if="item.userAvatarUrl" :src="item.userAvatarUrl">
                                            </div>
                                            <span class="name">{{item.userName}}</span>
                                        </div>
                                        <div class="text item">
                                            <el-tag v-if="item.active === 'online'" type="success">{{item.active}}</el-tag>
                                            <el-tag v-else type="danger">{{item.active}}</el-tag>
                                        </div>
                                    </div>
                                </el-card>
                            </div>
                        </div>
                    </transition-group>
                </div>
            </div>
            <div v-else>
                <myChat
                        :participants="participants"
                        :titleImageUrl="titleImageUrl"
                        :onMessageWasSent="onMessageWasSent"
                        :messageList="messageList"
                        :newMessagesCount="newMessagesCount"
                        :isOnline="isParticipantOnline"
                        :isOpen="isChatOpen"
                        :option="chatOption"
                        :closeAll="closeAll"
                        :close="closePanel"
                        :open="openChat"
                        :showEmoji="false"
                        :showFile="false"
                        :showTypingIndicator="showTypingIndicator"
                        :colors="colors"
                        :alwaysScrollToBottom="alwaysScrollToBottom"
                        :messageStyling="messageStyling"
                        @onType="handleOnType" />
            </div>
        </div>
        </transition>
    </div>
</template>

<script>
  import myChat from '../../components/vue-beautiful-chat2/src/Launcher.vue'
  import moment from 'moment'
  import axios from 'axios';
  import _ from 'lodash';

  export default {
    name: 'chatComponent',
    components: {
      myChat
    },
    props: [],
    computed:{},
    data() {
      return {
        chatOption: 'companyChat',
        list: false,
        activeUserList: [],
        companyUserId: '',
        activeUserIdList: [],
        // loading:false,
        isEnter: false,
        patnerName: '',
        groupChat:{
          userAvatarUrl:null,
          active: true,
          userName:'Group chat'
        },
        participants: [],
        titleImageUrl: '',
        messageList: [
          // { type: 'text', author: `me`, data: { text: `Say yes!` } },
          // { type: 'text', author: `user1`, data: { text: `Hello` } }
        ], // the list of the messages to show, can be paginated and adjusted dynamically
        newMessagesCount: 0,
        isChatOpen: false, // to determine whether the chat window should be open or closed
        showTypingIndicator: 0, // when set to a value matching the participant.id it shows the typing indicator for the specific user
        colors: {
          header: {
            bg: '#4e8cff',
            text: '#ffffff'
          },
          launcher: {
            bg: '#4e8cff'
          },
          messageList: {
            bg: '#ffffff'
          },
          sentMessage: {
            bg: '#4e8cff',
            text: '#ffffff'
          },
          receivedMessage: {
            bg: '#eaeaea',
            text: '#222222'
          },
          userInput: {
            bg: '#f4f7f9',
            text: '#565867'
          }
        }, // specifies the color scheme for the component
        alwaysScrollToBottom: true, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
        messageStyling: true, // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
        typing: false,
        timeout: undefined,
        isParticipantOnline: true
      }
    },
    mounted() {
      // var audio = new Audio(require('../to-the-point.ogg'))
      this.$options.sockets.event = (data) => {
        if(data.action === 'companyChatMessage' || data.action === 'companyUserChatMessage'){
          if(this.$route.query.companyId == data.companyId){
            // audio.play()
            this.showTypingIndicator = 0;
            if(this.companyUserId !== data.params.fromCompanyUserId && data.action !== 'companyChatMessage'){

              //check count of unread messages and update the list
              if(data.params.newCompanyUserMessageGroupList.length > 0){
                data.params.newCompanyUserMessageGroupList.forEach( val =>{
                  console.log('activeUserIdList', this.activeUserIdList)
                  let find = this.findUser2(this.activeUserIdList, val.fromCompanyUserId)
                  if(find === 'online'){
                    this.activeUserList.forEach( val2 => {
                      if (val2.companyUserId === val.fromCompanyUserId){
                        val2.newMessageCount = val.newMessageCount
                      }
                    })
                  }
                })
              }

              // const userBackground = require('../../assets/img/user-default.jpg')
              // console.log(userBackground)
              // if(data.params.fromUserAvatarUrl === null){
              //   data.params.fromUserAvatarUrl = userBackground
              // }
              // let card =  `<div style='display:flex; align-items: center; width: 255px;'>` +
              //   `<div style='background:${'url(' + userBackground + ');'} background-size: cover; border-radius: 50%; width: 50px; height: 50px; overflow: hidden; min-width: 50px; margin-right: 10px;' ><img style='width: 50px; height: 50px; border-radius: 50%; background-size: cover;' src="${data.params.fromUserAvatarUrl}"></div> \n` +
              //   `<div>`  + data.params.fromUserFullName + `</div> \n` +
              //   `</div> \n` +
              //   `<div> \n` +
              //   `<h4 style='line-height: 10px;'>Message: </h4>` +
              //   `<div style='width: 255px; overflow: hidden; text-overflow: ellipsis;'>` + data.params.message + `</div>` +
              //   `</div>`

              // this.notification("You have a message", card, "info");
            }
            // 42["event",{"action":"companyChatMessage","companyId":3,"fromUserId":16,"params":{"message":"ddasdasd","companyUserId":33,"createDate":1564641186,"userFullName":"jecozuh@mini-mail.net jecozuh@mini-mail.net","userAvatarUrl":"https://dev.taskbank.io/downloads/2019/07/31/4f7f04499b79c3206cb980ceb2a03d52.jpg"}}]
            // 42["event",{"action":"companyUserChatMessage","companyId":3,"fromUserId":12,"params":{"message":"sss","fromCompanyUserId":26,"createDate":1564580682,"fromUserFullName":"4444@cloud-mail.net 4444@cloud-mail.net","fromUserAvatarUrl":"https://dev.taskbank.io/downloads/2019/07/31/171542a93237bd49d233fede3c322219.jpg","toCompanyUserId":null}}]
            // if(this.companyUserId !== 'group' && data.action === 'companyChatMessage'){
            //   const userBackground = require('../../assets/img/group.png')
            //   let card =  `<div style='display:flex; align-items: center; width: 255px;'>` +
            //     `<div style='background:${'url(' + userBackground + ');'} background-size: cover; border-radius: 50%; width: 50px; height: 50px; overflow: hidden; min-width: 50px; margin-right: 10px;' ><img style='width: 50px; height: 50px; border-radius: 50%; background-size: cover;' src="${data.params.userAvatarUrl}"></div> \n` +
            //     `<div>`  + data.params.userFullName + `</div> \n` +
            //     `</div> \n` +
            //     `<div> \n` +
            //     `<h4 style='line-height: 10px;'>Message: </h4>` +
            //     `<div style='width: 255px; overflow: hidden; text-overflow: ellipsis;' >` + data.params.message + `</div>` +
            //     `</div>`
            //   this.notification("You have a group message", card, "info");
            // }

            console.log("partner name1", this.patnerName)
            console.log("partner name2", data.params.fromUserFullName)
            if(this.patnerName === data.params.fromUserFullName || this.patnerName === 'Group chat' && data.action === 'companyChatMessage'){

              //MARK AS READ WHEN IN SAME CHAT REQUEST
              if(this.patnerName === data.params.fromUserFullName){
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios
                    .post(`/api/v1/companyUserChat/markMessageListAsRead?companyId=${data.companyId}&fromCompanyUserId=${data.params.fromCompanyUserId}`)
                    .then(response => {
                      console.log('---', response.data);
                    })
                    .catch(error => {
                    })
              }


              let message = {
                type: 'text',
                author: data.params.companyUserId || data.params.fromCompanyUserId,
                data: { text: data.params.message,
                  meta: moment(data.params.createDate, 'X').format('DD/MM/YY LT')}
              };
              this.messageList.push(message)
            }
          }
      }
      },
      this.$options.sockets.companyUserListChanged = (data) => {
        console.log('data', data)
        console.log('this.activeUserList', this.activeUserList)
          for (let i = 0; i < this.activeUserList.length; i++ ){
              let find = this.findUser2(data.companyUserIdList, this.activeUserList[i].companyUserId)
              this.activeUserList[i].active = find
          }
          this.activeUserList =  _.orderBy(this.activeUserList, ['active', 'userName'], ['desc', 'asc'])
        // console.log(data)

        if(this.isChatOpen && this.companyUserId !== 'group'){
          let find = this.findUser2(data.companyUserIdList, this.companyUserId)
            if(find === 'online'){
              this.isParticipantOnline = true
            }else if (find === 'offline') {
              this.isParticipantOnline = false
            }
        }
      }
      // this.$options.sockets.event = (data) => {
      //   if(this.$route.query.companyId == data.companyId){
      //     audio.play()
      //     this.notification("You have a message", data.params.message, "info");
      //   }
      // }
      this.$options.sockets.companyChatTyping = (data) => {
        if(this.patnerName === 'Group chat'){
          this.participants.forEach(val =>{
            if (val.id === data.companyUserId && data.status === 'start'){
              this.showTypingIndicator = data.companyUserId
              // setTimeout(() => {
              //   this.showTypingIndicator = 0
              // }, 1000)
            }
            if (val.id === data.companyUserId && data.status === 'stop'){
              this.showTypingIndicator = 0
            }
          })
        }
      },
      this.$options.sockets.companyUserChatTyping = (data) => {
        console.log('data', data)
        console.log('this.participants', this.participants)
        if(this.isChatOpen && this.patnerName !== 'Group chat') {
          if (this.participants[0].id === data.fromCompanyUserId && data.status === 'start') {
            this.showTypingIndicator = data.fromCompanyUserId
          }
          if (this.participants[0].id === data.fromCompanyUserId && data.status === 'stop') {
            this.showTypingIndicator = 0
          }
        }
      },
      //update the list after read unread messages
      this.$options.sockets.event = (data) => {
        if(data.action === 'markCompanyUserChatMessageAsRead'){
          if(data.params.newCompanyUserMessageGroupList.length > 0){
            this.activeUserList.forEach(value => {
              value.newMessageCount = 0
            })
            data.params.newCompanyUserMessageGroupList.forEach( val =>{
              this.activeUserList.forEach( val2 => {
                if (val2.companyUserId === val.fromCompanyUserId){
                  val2.newMessageCount = val.newMessageCount
                }
              })
            })
          }else{
            this.activeUserList.forEach(value => {
              value.newMessageCount = 0
            })
          }
        }
      }
    },
    methods:{
      closeAll(){
        this.closePanel()
        this.closeModal()
      },
      openChat(){
        let loader = this.$loading.show();
        this.list = !this.list
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyUserChat/companyUserList?companyId=${this.$route.query.companyId} `)
          .then(response => {
            console.log('---', response.data);
            if(response.data.success){
              this.activeUserList = []
              this.activeUserIdList = []
              response.data.companyUserList.forEach(val => {
                let user = {
                  userName: val.userFullName,
                  companyUserId: val.id,
                  active: 'offline',
                  userAvatarUrl: val.userAvatarUrl,
                  newMessageCount: val.newMessageCount
                }
                this.activeUserList.push(user)
                this.activeUserIdList.push(val.id)
                })
                this.$store.dispatch('getCompanyLayout').then(resp => {
                    console.log('companyUserId', resp)
                    let data = {
                        companyId: this.$route.query.companyId,
                        companyUserId: resp.companyUserId
                    }
                    this.$socket.emit('companyChanged', data)
                })
              loader.hide()
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      enterRoom(partnerName, companyUserId, status, newMessageCount){
        let loader = this.$loading.show();
        // let loader = this.$loading.show();
        // alert(partnerName)
        // alert(companyUserId)
        this.patnerName = partnerName
        if(companyUserId){
          this.companyUserId = companyUserId
        }
        // let loader = this.$loading.show();

        if(partnerName === 'Group chat'){
          this.chatOption = 'companyGroupChat'
          this.companyUserId = 'group'
          this.activeUserList.forEach(val =>{
            // this.activeUserIdList.push(val.companyUserId)
            if(!val.userAvatarUrl){
              val.userAvatarUrl = '/img/user-default.5c6aa235.jpg'
            }
            let participant = {
              id: val.companyUserId,
              name: val.userName,
              imageUrl: val.userAvatarUrl
            }
            this.participants.push(participant)
            console.log('activeUserIdList', this.activeUserIdList)
          })
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companyChat/messageList?companyId=${this.$route.query.companyId}`)
            .then(response => {
              console.log('---', response.data);
              if(response.data.success){
                loader.hide()
                this.isChatOpen = !this.isChatOpen
                // loader.hide()
                response.data.list.forEach(val =>{
                  console.log(val)

                  let find = this.findUser(this.activeUserIdList, val.companyUserId)

                  let message = {
                    type: 'text',
                    author: find,
                    data: { text: val.message,
                      meta: moment(val.createDate, 'X').format('DD/MM/YY LT') + find},

                  }
                  this.messageList.push(message)
                })
              }
            })
            .catch(error => {
              loader.hide()
              // this.isChatOpen = !this.isChatOpen
              // loader.hide()
            })
        }else{
          this.chatOption = 'companyChat'
          if(status === 'online'){
            this.isParticipantOnline = true
          }else if (status === 'offline'){
            this.isParticipantOnline = false
          }
          // let myActiveUserIdList = []
          this.activeUserList.forEach(val =>{
            // myActiveUserIdList.push(val.companyUserId)
            if(!val.userAvatarUrl){
              val.userAvatarUrl = '/img/user-default.5c6aa235.jpg'
            }
            if(val.companyUserId == companyUserId){
              let participant = {
                id: val.companyUserId,
                name: val.userName,
                imageUrl: val.userAvatarUrl
              }
              this.participants.push(participant)
            }
          })
          // this.activeUserIdList = myActiveUserIdList

          if(newMessageCount){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/companyUserChat/markMessageListAsRead?companyId=${this.$route.query.companyId}&fromCompanyUserId=${companyUserId}`)
              .then(response => {
                console.log('---', response.data);
              })
              .catch(error => {
              })
          }

          console.log('activeUserIdList', this.activeUserIdList)
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companyUserChat/messageList?companyId=${this.$route.query.companyId}&companyUserId=${companyUserId}`)
            .then(response => {
              console.log('---', response.data);
              if(response.data.success){
                loader.hide()
                // loader.hide()
                response.data.list.forEach(val =>{
                  console.log(val)

                  let find = this.findUser(this.activeUserIdList, val.fromCompanyUserId)

                  let message = {
                    type: 'text',
                    author: find,
                    data: { text: val.message,
                      meta: moment(val.createDate, 'X').format('DD/MM/YY LT') }
                  }
                  this.messageList.push(message)
                })
                this.isChatOpen = !this.isChatOpen
              }
            })
            .catch(error => {
              loader.hide()
              // this.isChatOpen = !this.isChatOpen
              // loader.hide()
            })
        }
        console.log('PARTICIPATIONS', this.participants)
        console.log(partnerName)
      },
      findUser(arr, val){
        // console.log('arr', arr, 'val', val)
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] === val) {
            return val
          }
        }
        return 'me'
      },
      findUser2(arr, val){
        // console.log('arr', arr, 'val', val)
        for (let i = 0; i < arr.length; i++) {
            if (arr[i] === val) {
               return 'online'
            }
        }
        return 'offline'
      },
      closeModal(){
        this.list = false
      },
      closePanel(){
        this.chatOption = 'chatOption'
        this.patnerName = ''
        this.isParticipantOnline = false
        this.showTypingIndicator = 0
        this.companyUserId = ''
        this.participants = []
        this.messageList = []
        this.isChatOpen = false
      },
      onMessageWasSent (message) {
        console.log('message', message);
        // called when the user sends a message
        // alert('hello')
        if (message.data.text.length > 2048){
          this.notification("Notification", "Messsage to long", "info");
        }else{
          message.data.meta = moment().format('DD/MM/YY LT');
          this.messageList = [ ...this.messageList, message ];
          let data = {
            message: message.data.text,
          };
          if(this.patnerName === 'Group chat'){
            this.$socket.emit('companyChatTyping', 'stop')
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/companyChat/createMessage?companyId=${this.$route.query.companyId}`, data)
              .then(response => {
                console.log('---', response.data);
              })
              .catch(error => {

              });
          }else{
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/companyUserChat/create?companyId=${this.$route.query.companyId}&toCompanyUserId=${this.companyUserId}`, data)
              .then(response => {
                console.log('---', response.data);
              })
              .catch(error => {

              });
          }
        }
      },
      handleOnType (event) {
        if (event.keyCode !== 13){
          if(this.patnerName === 'Group chat'){
            console.log('this.groupChat.userName', this.patnerName)
            this.onKeyDownNotEnter()
            // this.$socket.emit('companyChatTyping', 'start')
          }else{
            this.onKeyDownNotEnterSingleRoom()
            // this.$socket.emit('companyUserChatTyping', 'start')
          }
        }
      },
      timeoutFunction(){
        this.typing = false;
        this.$socket.emit('companyChatTyping', 'stop')
      },
      onKeyDownNotEnter(){
        if(this.typing == false) {
          this.typing = true
          this.$socket.emit('companyChatTyping', 'start')
          this.timeout = setTimeout(this.timeoutFunction, 3000);
        } else {
          clearTimeout(this.timeout);
          this.timeout = setTimeout(this.timeoutFunction, 3000);
        }
      },
      onKeyDownNotEnterSingleRoom(){
        if(this.typing == false) {
          this.typing = true
          let data = {
            toCompanyUserId: this.companyUserId,
            toCompanyId: this.$route.query.companyId,
            status: 'start'
          }
          this.$socket.emit('companyUserChatTyping', data)
          this.timeout = setTimeout(this.timeoutFunctionSingleRoom, 3000);
        } else {
          clearTimeout(this.timeout);
          this.timeout = setTimeout(this.timeoutFunctionSingleRoom, 3000);
        }
      },
      timeoutFunctionSingleRoom(){
        this.typing = false;
        let data = {
          toCompanyUserId: this.companyUserId,
          toCompanyId: this.$route.query.companyId,
          status: 'stop'
        }
        this.$socket.emit('companyUserChatTyping', data)
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          dangerouslyUseHTMLString: true,
          message: message,
          type: type,
          customClass:"message-notification"
        });
      }
    },
    beforeDestroy(){
      console.log('destroy chat')
      console.log(this.socket)
    },
    watch:{
      // '$route'(to, old) {
        // if(this.list) this.list = false;
      // }
    }
  }
</script>

<style lang="less" scoped>
    .my-list{
        z-index:2;
        width: 370px;
        height: calc(100% - 120px);
        max-height: 590px;
        position: fixed;
        right: 25px;
        bottom: 100px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-box-shadow: 0px 7px 40px 2px rgba(148, 149, 150, 0.1);
        box-shadow: 0px 7px 40px 2px rgba(148, 149, 150, 0.1);
        background: white;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-transition: 0.3s ease-in-out;
        transition: 0.3s ease-in-out;
        border-radius: 10px;
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    }
    .list{
        height:100%;
        overflow-x:hidden;
    }
    /deep/.sc-chat-window{
        z-index:2;
        .img-msg{
            height:50px;
        }
    }
    .sc-header{
        min-height: 75px;
        border-top-left-radius: 9px;
        border-top-right-radius: 9px;
        padding: 10px;
        -webkit-box-shadow: 0 1px 4px rgba(0,0,0,.2);
        box-shadow: 0 1px 4px rgba(0,0,0,.2);
        position: relative;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        background: rgb(78, 140, 255);
        color: rgb(255, 255, 255);
    }
    .title{
      color: #fff;
        align-self: center;
        padding: 10px;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor: pointer;
        border-radius: 5px;
        &:hover{
            box-shadow: 0px 2px 5px rgba(0.2, 0.2, 0.5, .1);
        }
    }
    .close-button{
        width: 40px;
        -ms-flex-item-align: center;
        align-self: center;
        height: 40px;
        margin-right: 10px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        cursor: pointer;
        border-radius: 5px;
        display:flex;
        justify-content:center;
        align-items:center;
        &:hover{
            box-shadow: 0px 2px 5px rgba(0.2, 0.2, 0.5, .1);
        }
    }
    .el-icon-close{
        font-size:25px;
    }
    .box-card{
        margin:2px 0;
        cursor:pointer;
        &__wrap{
            display:flex;
            justify-content:space-between;
            .photo-group{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 20px;
                background: url('~@/assets/img/group.png');
                background-size: cover;
            }
            .name{
                font-size:14px;
            }
            .photo {
                position:relative;
                width: 50px;
                min-width:50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 20px;
                background: url('~@/assets/img/user-default.jpg');
                background-size: cover;
                .item-badge{
                    position: absolute;
                    right: -10px;
                    top: -3px;
                }
                img {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    // background: url('~@/assets/img/user-default.jpg');
                    background-size: cover;
                }
            }
        }
        &:hover{
            box-shadow: 0px 5px 5px rgba(0.5, 0.5, 0.5, .2);
        }
    }
    .flex{
        display:flex;
        align-items:center;
    }
    /deep/.received{
        .chatLink{
            color:#409EFF;
        }
    }
    /deep/.sent {
        .chatLink{
            color:black;
        }
    }
    .flip-list-move {
        transition: transform 1s;
    }
</style>

<style lang="less">
    .sc-launcher{
    display:none !important;
    }
    .list{
        .el-card__body{
            padding:8px;
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }
</style>
